module.exports = __webpack_public_path__ + "static/introduction-img-ef3a8e1b57998286b5a369d538bb64a0.png";